<template>
  <div aria-labelledby="recent-library-folders" class="recent-library">
    <h3 id="recent-library-folders">{{ betaVisibility ? 'Library' : 'Recent Library Folders' }}</h3>
    <p class="loading-notice text-muted" v-if="loading"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading recent library folders...</p>
    <div
      class="alert alert-danger"
      role="alert"
      v-if="error">Error loading library folders. Please refresh the page and try again.</div>
    <ul class="fa-ul">
      <li
        class="folder-list"
        v-for="student, idx in recentStudents"
        :key="student.uuid">
        <router-link
          class="folder-name"
          :to="{name: 'StudentLibraryPage', params: {uuid: student.uuid}, query: {position: idx + 1, ref: 'home', updatedAt: student.updated_at}}"
          :aria-label="`Library folder: ${student.name}`"
        > <span class="fa-li"><i class="fa fa-folder fa-lg"/></span>
          {{ truncate(student.name) }}
        </router-link>
        <span class="folder-time">Updated {{ getRelativeTime(student.updated_at) }}</span>
      </li>
    </ul>
    <router-link
      v-if="recentStudents.length && !betaVisibility"
      :to="{ name: 'Library', query: { ref: 'home' } }"
    >View all folders</router-link
    >
    <a :href="`${this.home}/v/library/all?beta=true`" v-if="betaVisibility">View all folders</a>

    <p v-if="!recentStudents.length" class="empty-library">You don't have any folders in your library.</p>
    <router-link v-if="!recentStudents.length" :to="{name: 'Library', query: {ref: 'home'}}"><button class="new-folder-btn">Create new folder</button></router-link>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { formatDistance, parseISO } from 'date-fns'
import { toolkitUrls } from '@/links'

export default {
  name: 'RecentLibraryFolders',
  data() {
    return {
      loading: false,
      error: false,
      ...toolkitUrls,
    }
  },
  computed: {
    ...mapState('user', {
      userUuid: state => state.user.uuid
    }),
    ...mapState('library', {
      recentStudents: state =>  {
        return state.recentStudents.length > 3 ? state.recentStudents.slice(0, -1) : state.recentStudents
      }
    }),
    ...mapGetters('visibility', ['betaVisibility']),
  },
  watch: {
    userUuid(newVal, _) {
      if (newVal) {
        this.loading = true;
        this.loadRecentStudents()
      }
    }
  },
  methods: {
    ...mapActions('library', ['fetchRecentStudents']),
    async loadRecentStudents() {
      try {
        await this.fetchRecentStudents(this.userUuid)
        this.loading = false
      } catch (err) {
          console.error(`Error fetching recent students: ${err}`)
          this.loading = false
          this.error = true
      }
    },
    getRelativeTime(timestamp) {
      const parsedDate = parseISO(timestamp);
      return formatDistance(parsedDate, new Date(), {addSuffix: true})
    },
    truncate(str) {
      if (str.length < 34) {
        return str
      }
      return str.substring(0, 34) + '...'
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/variables.less';
  h3 {
      margin-bottom: 1rem;
      color: @header-text-dark;
  }
  .fa-folder {
      color: @folder-gray;
  }
  .fa-ul {
    width: 60%;
  }
  .fa-li {
      top: 0;
      left: -2rem;
  }
  .fa-lg {
      font-size: 2rem;
  }
  .folder-list {
      margin-bottom: 1rem;
      font-size: 1rem;
      display: flex;
      justify-content: space-between;
  }
  .folder-name {
      margin-left: 10px;
  }
  .folder-time {
      font-size: 0.8rem;
      font-style: italic;
      text-align: right;
  }
  .recent-library {
    margin-bottom: 2rem;
  }
  a:focus {
    outline: 2px solid lighten(@link-color, 20%);;
    outline-offset: 3px;
  }
  .empty-library {
    font-style: italic;
    margin-top: 2rem;
  }
  .new-folder-btn {
    background-color: #fff;
    color: @gb_blue_medium;
    border: 2px solid @gb_blue_medium;
    border-radius: 6px;
    padding: 4px 12px;
  }

  @media (max-width: @screen-md) {
      .folder-time {
          display: none;
      }
      .folder-name {
          width: 100%;
      }
  }
</style>